export enum SearchViewMode {
  Grid = 'grid',
  List = 'list',
}

export interface SearchViewModeState {
  intermediateValue: SearchViewMode | null;
  committedValue: SearchViewMode;
}

export const DEFAULT_SEARCH_VIEW: SearchViewModeState = {
  intermediateValue: null,
  committedValue: SearchViewMode.Grid,
};

export const SEARCH_VIEW_KEY = 'SEARCH_VIEW_KEY_V2';
